import { React, useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

import FetchModule from '../../Model/Share/Network/FetchModule.js';
import { useLanguage } from '../../Context/LanguageContext';

import MyStoreSettingTopModel from '../Component/MyStoreSettingTopModel.js';
import MyAccountBox from '../Component/MyAccountBox.js';
import MyStoreIntroductionBox from '../Component/MyStoreIntroductionBox.js';
import ProgramFollowBox from '../Component/ProgramFollowBox.js';
import PartnerGymFollowBox from '../Component/PartnerGymFollowBox.js';
import TermContract from '../Component/TermContract.js';
// 약관 모달은 TermContract 내부에서 소유 (TermsEditModal/TermsDeleteModal) //
import BillingBox from '../Component/BillingBox.js';
import MemberListExportModal from '../../Model/Individual/MySettingModel/MemberListExportModal.js';
import useTossCardRegister from '../../Model/Share/Normal/useTossCardRegister.js';

export default function MyStoreSettingPage() {
  const history = useHistory();
  const { t } = useLanguage();

  const registerCard = useTossCardRegister();

  const [isViewBillingInfoModal, setIsViewBillingInfoModal] = useState(false);
  const [isClickedModify, setIsClickedModify] = useState(false);

  const [subscriptionSummary, setSubscriptionSummary] = useState(null);

  const [isClickedModifyAccount, setIsClickedModifyAccount] = useState(false);
  const [isClickedModifyGymInfo, setIsClickedModifyGymInfo] = useState(false);
  const [isClickedLinkoPay, setIsClickedLinkoPay] = useState(false);

  const [data, setData] = useState(undefined);
  const [subscribeList, setSubscribeList] = useState(new Array);
  const [rendering, setRendering] = useState(false);

  const [exerciseFollows, setExerciseFollows] = useState([]);
  const [exerciseFollowers, setExerciseFollowers] = useState([]);

  const [partnerGymFollows, setPartnerGymFollows] = useState([]);
  const [partnerGymFollowers, setPartnerGymFollowers] = useState([]);

  const [linkopay, setLinkopay] = useState(undefined);

  const [businessRegistrationNumber, setBusinessRegistrationNumber] = useState('');
  const [representativeName, setRepresentativeName] = useState('');
  const [linkoEmail, setLinkoEmail] = useState('');
  const [bankName, setBankName] = useState('');
  const [accountNumber, setAccountNumber] = useState('');
  const [settleCycle, setSettleCycle] = useState(5);
  const [settleCycleUnit, setSettleCycleUnit] = useState('day');
  const [linkopayStoreName, setLinkopayStoreName] = useState('');
  const [linkopayBusinessLicenseUrl, setLinkopayBusinessLicenseUrl] = useState('');
  const [linkopayBusinessLicenseFileName, setLinkopayBusinessLicenseFileName] = useState('');
  const [linkopayPhone, setLinkopayPhone] = useState('');
  const [linkopayCountryCode, setLinkopayCountryCode] = useState('');
  const [linkopayHolderName, setLinkopayHolderName] = useState('');

  const [id, setId] = useState('');
  const [email, setEmail] = useState('');
  const [ownerName, setOwnerName] = useState('');
  const [ownerProfile, setOwnerProfile] = useState('');
  const [phone, setPhone] = useState('');
  const [phoneCountryCode, setPhoneCountryCode] = useState('');
  const [passwordModifiedAt, setPasswordModifiedAt] = useState(null);
  const [secondPasswordModifiedAt, setSecondPasswordModifiedAt] = useState(null);
  const [storeLogo, setStoreLogo] = useState('');
  const [storeLogoThumbnail, setStoreLogoThumbnail] = useState('');
  const [storeName, setStoreName] = useState('');
  const [tel, setTel] = useState('');
  const [type, setType] = useState('');
  const [address, setAddress] = useState('');
  const [openingHour, setOpeningHour] = useState('');
  const [storeIntro, setStoreIntro] = useState('');
  const [profiles, setProfiles] = useState([]);
  const [profileThumbnails, setProfileThumbnails] = useState([]);
  // TODO(payment-page-migration): 결제 시스템 사용 여부 토글은 별도 페이지로 이전 예정. 백엔드 데이터 보존을 위해 state는 유지 //
  const [isUsePaymentSystem, setIsUsePaymentSystem] = useState('No');

  const [isClickedExportExcelModal, setIsClickedExportExcelModal] = useState(false);

  // 약관 모달 상태 및 저장/삭제/토글 로직은 TermContract 내부로 이전 //

  const [terms, setTerms] = useState([]);

  // 사진 변경 디바운스 동기화용 ref //
  const isPhotoSyncReadyRef = useRef(false);
  const photoSyncTimerRef = useRef(null);

  const [defaultProvisions, setDefaultProvisions] = useState([
    {
      id: 0,
      isDefault: true,
      title: t('myStoreSetting.terms.defaultProvision1Title'),
      text: t('myStoreSetting.terms.defaultProvision1Text')
    },
    {
      id: 0,
      isDefault: true,
      title: t('myStoreSetting.terms.defaultProvision2Title'),
      text: t('myStoreSetting.terms.defaultProvision2Text')
    }
  ])

  const [provisions, setProvisions] = useState([]);

  useEffect(() => {
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.getIndividualData('account/find', 'GET');

        if (responseData.status === 200) setData(responseData.data[0]);
        else if (responseData.status === 401) history.push('/');

        const subscribeResponseData = await fetchModule.getIndividualData('zone_subscribe/list');

        if (subscribeResponseData.status === 200) {

          let subscribeList = subscribeResponseData.data.slice();

          subscribeList.sort(function (a, b) {
            let x = a.approvalDate;
            let y = b.approvalDate;

            if (x < y) return 1;
            if (x > y) return -1;
          })

          let finalSubscribes = [];
          let subscribeCount = 0;

          for (let i = 0; i < subscribeList.length; i++) {
            if ((subscribeList[i].itemName === 'Link-Zone 정기 구독권' 
              || subscribeList[i].itemName === 'Link-Zone 정기 구독권 (1개월)')
              && subscribeCount < 2) {
              finalSubscribes.push(subscribeList[i]);
              subscribeCount += 1;
            }
            else if (subscribeList[i].itemName !== 'Link-Zone 정기 구독권'
              && subscribeList[i].itemName !== 'Link-Zone 정기 구독권 (1개월)'
              && !subscribeList[i].itemName.includes('카카오 알림톡 사용')
            ) finalSubscribes.push(subscribeList[i]);
          }

          setSubscribeList(finalSubscribes);
        }

        // 구독/카드 통합 조회 (Section 6 좌측 카드 표시값) //
        const summaryResponseData = await fetchModule.getDataVersion2('billing/subscription_summary', 'GET');

        if (summaryResponseData.status === 200) setSubscriptionSummary(summaryResponseData.data);
        else if (summaryResponseData.status === 204) setSubscriptionSummary(null);
        else if (summaryResponseData.status === 401) history.push('/');
      }
    )();
  }, [history, rendering])

  // 센터 약관 불러오기 //
  useEffect(() => {
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.getDataVersion2('terms/', 'GET');

        if (responseData.status === 200) {
          setTerms(responseData.data.terms);
          setProvisions(responseData.data.provisions);
        }
      }
    )();
  }, [])

  // 운동 프로그램 팔로우 데이터 //
  useEffect(() => {
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.getDataOfExerciseVersion2('share/', 'GET');
        
        if (responseData.status === 200) {
          setExerciseFollows(responseData.data.follows);
          setExerciseFollowers(responseData.data.followers);
        }
      }
    )();
  }, [])

  // 파트너 체육관 데이터 //
  useEffect(() => {
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.getDataVersion2('partner_gym/', 'GET');
        if (responseData.status === 200) {
          setPartnerGymFollows(responseData.data.follows);
          setPartnerGymFollowers(responseData.data.followers);
        }
      }
    )();
  }, [])

  // 링코페이 데이터 //
  useEffect(() => {
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.getDataVersion2('account/linkopay_permission', 'GET');
        if (responseData.status === 200) {
          if (responseData.data !== undefined) {
            setLinkopay(responseData.data);
            setBusinessRegistrationNumber(responseData.data.businessRegistrationNumber);
            setRepresentativeName(responseData.data.representativeName);
            setLinkoEmail(responseData.data.email);
            setBankName(responseData.data.bankName);
            setAccountNumber(responseData.data.accountNumber);
            setSettleCycle(responseData.data.settlementCycle);
            setSettleCycleUnit(responseData.data.settlementCycleUnit);
            setLinkopayStoreName(responseData.data.storeName);
            setLinkopayBusinessLicenseUrl(responseData.data.businessLicenseUrl);
            setLinkopayBusinessLicenseFileName(responseData.data.businessLicenseFileName);
            setLinkopayPhone(responseData.data.phone);
            setLinkopayCountryCode(responseData.data.countryCode);
            setLinkopayHolderName(responseData.data.holderName);
          }
        }
      }
    )();
  }, [])

  // Data Setting //
  useEffect(() => {
    if (data === undefined) return;

    setId(data.loginId);
    setEmail(data.email);
    setOwnerName(data.ownerName);
    setOwnerProfile(data.ownerProfile || '');
    setPhone(data.phone);
    setPhoneCountryCode(data.countryCode || '');
    setPasswordModifiedAt(data.passwordModifiedAt ?? null);
    setSecondPasswordModifiedAt(data.secondPasswordModifiedAt ?? null);
    setStoreLogo(data.storeLogo);
    setStoreLogoThumbnail(data.storeLogoThumbnail);
    setStoreName(data.storeName);
    setAddress(data.storeAddress);
    setTel(data.storeTel);
    setType(data.storeType);
    setOpeningHour(data.openingHour);
    setStoreIntro(data.introduce);
    setIsUsePaymentSystem(data.isUsePaymentSystem);

    const newData = parseProfilesFromData(data);

    setProfiles(newData);
    setProfileThumbnails(newData);
  }, [data])

  // 사진 변경(추가/정렬/삭제) 1초 디바운스 후 백엔드 동기화 //
  useEffect(() => {
    if (data === undefined) return;

    if (!isPhotoSyncReadyRef.current) {
      isPhotoSyncReadyRef.current = true;
      return;
    }

    if (photoSyncTimerRef.current) clearTimeout(photoSyncTimerRef.current);

    photoSyncTimerRef.current = setTimeout(() => {
      silentSyncCenterInfo();
    }, 1000);

    return () => {
      if (photoSyncTimerRef.current) clearTimeout(photoSyncTimerRef.current);
    };
  }, [profiles, profileThumbnails])

  const parseProfilesFromData = (data) => {
    let dates = Array.isArray(data.profiles) ? data.profiles : data.profiles.split(',');
    return dates.filter(date => date !== '');
  };

  const createCenterInfoRequestData = () => ({
    centerName: storeName,
    tel: tel,
    type: type,
    address: address,
    openingHour: openingHour,
    isUsePaymentSystem: isUsePaymentSystem,
    introduce: storeIntro,
    logo: storeLogo,
    logoThumbnail: storeLogoThumbnail,
    profiles: profiles
  });

  const updateCenterInfo = async (requestData) => {
    const fetchModule = new FetchModule();

    const responseData = await fetchModule.postDataVersion2('account/center_info/update', 'POST', requestData);

    if (responseData.status === 200) {
      // TopBar 프로필 사진 업데이트 //
      if (window.refreshStoreLogo) {
        window.refreshStoreLogo();
      }

      // 저장 응답으로 setData 가 useEffect[data]→setProfiles→useEffect[profiles] 를 트리거 하면 중복 silent sync 가 발생 → 응답 처리 직전 ready 플래그를 false 로 리셋해 한 번 무시 //
      isPhotoSyncReadyRef.current = false;
      setData(responseData.data);
      setIsClickedModifyGymInfo(false);
    }
    else if (responseData.status === 201) {
      alert(t('myStoreSetting.alert.paymentSystemRestricted'));
      setIsUsePaymentSystem('No');
    }
    else if (responseData.status === 401) {
      history.push('/');
    }
  };

  // 사진 변경 무음 동기화 (디바운스 후 호출) — 알림/모드 변경/응답 데이터 갱신 없음 //
  function silentSyncCenterInfo() {
    const requestData = createCenterInfoRequestData();
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('account/center_info/update', 'POST', requestData);

        if (responseData.status === 401) history.push('/');
      }
    )();
  }

  // 관리 버튼 클릭시 — suspensionCode 있으면 결제 정보 모달, 없으면 구독 관리 모달 //
  function onClickManageBilling() {
    setIsViewBillingInfoModal(true);
  }

  // 등록하기 버튼 클릭시 (미등록 상태) — 토스 카드 등록 즉시 트리거 //
  // 실패 시에는 별도 경로로 이동하지 않고 현재 페이지 유지 (토스 모달만 닫힘) //
  function onClickRegisterCard() {
    registerCard({
      successPath: '/payment/zone/card/register/success'
    });
  }

  // 센터 정보 저장하기 클릭시 //
  function onClickGymIntroSave() {
    if (storeName === '') {
      alert(t('myStoreSetting.alert.ownerNameRequired'));
      return;
    }
    else if (tel === '') {
      alert(t('myStoreSetting.alert.phoneRequired'));
      return;
    }
    else if (type === '') {
      alert(t('myStoreSetting.centerInfo.selectCenterType'));
      return;
    }

    const requestData = createCenterInfoRequestData();

    updateCenterInfo(requestData);
  }

  // 데이터 수정중 다른 컴포넌트 수정하기 버튼 클릭시 자동 저장 //
  function autoSave() {
    // 계정 정보 수정중 다른 컴포넌트 수정 클릭시 //
    if (isClickedModifyAccount) {
      if (ownerName === '') {
        alert(t('myStoreSetting.alert.ownerNameRequired'));
        return false;
      }
      else if (phone === '' || phone.length !== 11) {
        alert(t('myStoreSetting.alert.phoneRequired'));
        return false;
      }

      const requestData = {
        ownerName: ownerName,
        phone: phone,
      }
      
      const fetchModule = new FetchModule();
      (
        async () => {
          const responseData = await fetchModule.postDataVersion2('account/info/modify', 'POST', requestData);

          if (responseData.status === 200) {
            isPhotoSyncReadyRef.current = false;
            setData(responseData.data);
          }
          else if (responseData.status === 401) history.push('/');
        }
      )();

      setIsClickedModifyAccount(false);

      return true;
    }
    // 센터 정보 수정중 다른 컴포넌트 수정 클릭시 //
    else if (isClickedModifyGymInfo) {
      if (storeName === '') {
        alert(t('myStoreSetting.alert.ownerNameRequired'));
        return false;
      }
      else if (tel === '') {
        alert(t('myStoreSetting.alert.phoneRequired'));
        return false;
      }
      else if (type === '') {
        alert(t('myStoreSetting.centerInfo.selectCenterType'));
        return false;
      }

      const requestData = createCenterInfoRequestData();

      (async () => {
        await updateCenterInfo(requestData);
      })();

      return true;
    }
    else return true;
  }

  // 센터 정보 수정하기 클릭시 //
  function onClickModifyCenterInfo() {
    if (!isClickedModifyGymInfo) {
      if (autoSave()) setIsClickedModifyGymInfo(true);
    }
    else {
      onClickGymIntroSave();
    }
  }

  // 운동 프로그램 팔로우 신청 클릭시 //
  function onClickExerciseFollowApplicateButton(data, isFollow) {
    // 팔로우 창에서 실행된 경우 //
    if (isFollow) {
      if (data.status === undefined) {
        let requestData = {
          followStoreId: data.storeId
        }
    
        const fetchModule = new FetchModule();
        (
          async () => {
            const responseData = await fetchModule.postDataOfExerciseVersion2('share/application', 'POST', requestData);

            if (responseData.status === 200) {
              setExerciseFollows(responseData.data.follows);
              setExerciseFollowers(responseData.data.followers);
            }
          }
        )();
      }
      else {
        let requestData = {
          shareId: data.shareId
        }
    
        const fetchModule = new FetchModule();
        (
          async () => {
            const responseData = await fetchModule.postDataOfExerciseVersion2('share/delete', 'POST', requestData);
            
            if (responseData.status === 200) {
              setExerciseFollows(responseData.data.follows);
              setExerciseFollowers(responseData.data.followers);
            }
          }
        )();
      }
    }
    // 팔로워 창에서 실행된 경우 //
    else {
      if (!data.status) {
        let requestData = {
          shareId: data.shareId
        }
    
        const fetchModule = new FetchModule();
        (
          async () => {
            const responseData = await fetchModule.postDataOfExerciseVersion2('share/apply', 'POST', requestData);
            
            if (responseData.status === 200) {
              alert(t('myStoreSetting.alert.followApproved'));
              setExerciseFollows(responseData.data.follows);
              setExerciseFollowers(responseData.data.followers);
            }
          }
        )();
      }
      else {
        let requestData = {
          shareId: data.shareId
        }
    
        const fetchModule = new FetchModule();
        (
          async () => {
            const responseData = await fetchModule.postDataOfExerciseVersion2('share/delete', 'POST', requestData);
            
            if (responseData.status === 200) {
              setExerciseFollows(responseData.data.follows);
              setExerciseFollowers(responseData.data.followers);
            }
          }
        )();
      }
    }
  }

  // 파트너 체육관 팔로우 신청 클릭시 //
  function onClickPartnerGymFollowApplicateButton(data, isFollow, permissions) {
    // 팔로우 창에서 실행된 경우 //
    if (isFollow) {
      if (data.status === undefined) {
        let requestData = {
          followStoreId: data.storeId,
          ...(permissions || {})
        }

        const fetchModule = new FetchModule();
        (
          async () => {
            const responseData = await fetchModule.postDataVersion2('partner_gym/application', 'POST', requestData);

            if (responseData.status === 200) {
              setPartnerGymFollows(responseData.data.follows);
              setPartnerGymFollowers(responseData.data.followers);
            }
            else if (responseData.status === 201) {
              if (!window.confirm(t('myStoreSetting.alert.partnerAlreadyRequested'))) return;

              const applyRequestData = {
                partnerId: responseData.data.partnerId,
                ...(permissions || {})
              }
              const applyResponseData = await fetchModule.postDataVersion2('partner_gym/apply', 'POST', applyRequestData);

              if (applyResponseData.status === 200) {
                alert(t('myStoreSetting.alert.followApproved'));
                setPartnerGymFollows(applyResponseData.data.follows);
                setPartnerGymFollowers(applyResponseData.data.followers);
              }
            }
          }
        )();
      }
      else {
        let requestData = {
          partnerId: data.partnerId
        }
        
        const fetchModule = new FetchModule();
        (
          async () => {
            const responseData = await fetchModule.postDataVersion2('partner_gym/delete', 'POST', requestData);
            
            if (responseData.status === 200) {
              setPartnerGymFollows(responseData.data.follows);
              setPartnerGymFollowers(responseData.data.followers);
            }
          }
        )();
      }
    }
    // 팔로워 창에서 실행된 경우 //
    else {
      if (!data.status) {
        let requestData = {
          partnerId: data.partnerId,
          ...(permissions || {})
        }

        const fetchModule = new FetchModule();
        (
          async () => {
            const responseData = await fetchModule.postDataVersion2('partner_gym/apply', 'POST', requestData);
            
            if (responseData.status === 200) {
              alert(t('myStoreSetting.alert.followApproved'));
              setPartnerGymFollows(responseData.data.follows);
              setPartnerGymFollowers(responseData.data.followers);
            }
          }
        )();
      }
      else {
        let requestData = {
          partnerId: data.partnerId
        }
    
        const fetchModule = new FetchModule();
        (
          async () => {
            const responseData = await fetchModule.postDataVersion2('partner_gym/delete', 'POST', requestData);
            
            if (responseData.status === 200) {
              setPartnerGymFollows(responseData.data.follows);
              setPartnerGymFollowers(responseData.data.followers);
            }
          }
        )();
      }
    }
  }

  // 파트너 체육관 신청 거절 (followers status=false) //
  function onClickPartnerGymFollowerReject(data) {
    let requestData = { partnerId: data.partnerId };

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('partner_gym/delete', 'POST', requestData);

        if (responseData.status === 200) {
          alert(t('myStoreSetting.alert.followDeleted'));
          setPartnerGymFollows(responseData.data.follows);
          setPartnerGymFollowers(responseData.data.followers);
        }
      }
    )();
  }

  // 파트너 체육관 권한 수정 저장 //
  function onClickPartnerGymPermissionSave(data, permissions) {
    let requestData = {
      partnerId: data.partnerId,
      isOpenSales: permissions.isOpenSales,
      isOpenReservation: permissions.isOpenReservation
    };

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('partner_gym/permission', 'POST', requestData);

        if (responseData.status === 200) {
          alert(t('myStoreSetting.alert.permissionSaved'));
          setPartnerGymFollows(responseData.data.follows);
          setPartnerGymFollowers(responseData.data.followers);
        }
        else if (responseData.status === 401) {
          // 권한 위반 (남의 row 수정 시도 등) — 토큰 만료와 분기 //
          if (responseData.error === 'Forbidden: not your partner row') {
            alert(t('myStoreSetting.alert.permissionForbidden'));
            // 최신 상태로 동기화 //
            const refreshResponse = await fetchModule.getDataVersion2('partner_gym/', 'GET');
            if (refreshResponse.status === 200) {
              setPartnerGymFollows(refreshResponse.data.follows);
              setPartnerGymFollowers(refreshResponse.data.followers);
            }
          }
          else {
            history.push('/');
          }
        }
      }
    )();
  }

  // REMOVED-PROVISION-UI: 신규 디자인에서 메인의 provision/alert 모달 폐기로 핸들러 7개 제거 — git history 참조 //
  // 약관 모달 상태/저장/삭제/토글 핸들러 9개는 TermContract 내부로 이전 //

  const linkopayProps = {
    data: linkopay,
    setData: setLinkopay,
    businessRegistrationNumber: businessRegistrationNumber,
    setBusinessRegistrationNumber: setBusinessRegistrationNumber,
    representativeName: representativeName,
    setRepresentativeName: setRepresentativeName,
    email: linkoEmail,
    setEmail: setLinkoEmail,
    bankName: bankName,
    setBankName: setBankName,
    accountNumber: accountNumber,
    setAccountNumber: setAccountNumber,
    settleCycle: settleCycle,
    setSettleCycle: setSettleCycle,
    settleCycleUnit: settleCycleUnit,
    setSettleCycleUnit: setSettleCycleUnit,
    storeName: linkopayStoreName,
    setStoreName: setLinkopayStoreName,
    businessLicenseUrl: linkopayBusinessLicenseUrl,
    setBusinessLicenseUrl: setLinkopayBusinessLicenseUrl,
    businessLicenseFileName: linkopayBusinessLicenseFileName,
    setBusinessLicenseFileName: setLinkopayBusinessLicenseFileName,
    phone: linkopayPhone,
    setPhone: setLinkopayPhone,
    countryCode: linkopayCountryCode,
    setCountryCode: setLinkopayCountryCode,
    holderName: linkopayHolderName,
    setHolderName: setLinkopayHolderName
  };

  return (
    <Container>
      { isClickedExportExcelModal && <MemberListExportModal onClickExit={() => setIsClickedExportExcelModal(false)} /> }
      
      <MyStoreSettingTopModel onClickDownloadMemberList={setIsClickedExportExcelModal} />
      
      <MyAccountBox
        id={id}
        email={email}
        owenrName={ownerName}
        setOwnerName={setOwnerName}
        ownerProfile={ownerProfile}
        phone={phone}
        phoneCountryCode={phoneCountryCode}
        setPhone={setPhone}
        setPhoneCountryCode={setPhoneCountryCode}
        passwordModifiedAt={passwordModifiedAt}
        secondPasswordModifiedAt={secondPasswordModifiedAt}
        refetchAccount={() => setRendering(!rendering)}
        linkopayProps={linkopayProps} />

      <MyStoreIntroductionBox
        isClicked={isClickedModifyGymInfo}
        onClickModifyCenterInfo={onClickModifyCenterInfo}
        data={data}
        storeLogo={storeLogo}
        setStoreLogo={setStoreLogo}
        storeLogoThumbnail={storeLogoThumbnail}
        setStoreLogoThumbnail={setStoreLogoThumbnail}
        storeName={storeName}
        setStoreName={setStoreName}
        tel={tel}
        setTel={setTel}
        type={type}
        setType={setType}
        address={address}
        setAddress={setAddress}
        storeIntro={storeIntro}
        setStoreIntro={setStoreIntro}
        profiles={profiles}
        profileThumbnails={profileThumbnails}
        setData={setData} />

      <TermContract
        storeName={storeName}
        terms={terms}
        setTerms={setTerms}
        provisions={provisions}
        setProvisions={setProvisions}
        defaultProvisions={defaultProvisions} />

      <ProgramFollowBox
        follows={exerciseFollows}
        followers={exerciseFollowers}
        onClickFollow={onClickExerciseFollowApplicateButton}/>

      <PartnerGymFollowBox
        follows={partnerGymFollows}
        followers={partnerGymFollowers}
        onClickFollow={onClickPartnerGymFollowApplicateButton}
        onClickFollowerReject={onClickPartnerGymFollowerReject}
        onClickPermissionSave={onClickPartnerGymPermissionSave}/>

      <BillingBox
        subscribeList={subscribeList}
        subscriptionSummary={subscriptionSummary}
        onClickManage={onClickManageBilling}
        onClickRegister={onClickRegisterCard}
        isViewBillingInfoModal={isViewBillingInfoModal}
        onCloseBillingInfoModal={() => setIsViewBillingInfoModal(false)}/>
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  flex-direction: column;

  // width: 100%;
  width: calc(100% - 28px);

  user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;

  input, textarea {
    user-select: text;
    -webkit-user-select: text;
    -ms-user-select: text;
  }
`;